export const formatTime = (seconds: number, options?: { min?: number }) => {
  if (options?.min !== undefined) {
    seconds = Math.max(options.min, seconds);
  }

  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);

  return `${mins.toString().padStart(2, "0")}:${secs
    .toString()
    .padStart(2, "0")}`;
};
